import React, { FC } from 'react';
import { Renew24 } from '@carbon/icons-react';

export const AnimatedIcon: FC = () => (
    <span className="animate-spin mr-2">
        <Renew24 className="-scale-x-[1]" />
    </span>
);
